import React from 'react';
import { fc, mk } from '../../utils';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function SpendingHeatmapCard({ state }) {
  const now = new Date();
  const months = [0, 1, 2].map((i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    return mk(d.getFullYear(), d.getMonth());
  });

  const byDay = [0, 0, 0, 0, 0, 0, 0];
  let total = 0;

  months.forEach((key) => {
    const vs = (state.varSpend || {})[key] || {};
    Object.values(vs).flat().forEach((entry) => {
      if (!entry.ts) return;
      const d = new Date(entry.ts).getDay();
      byDay[d] += entry.amt || 0;
      total += entry.amt || 0;
    });
  });

  if (total === 0) return null;

  const maxDay = Math.max(...byDay);
  const topDayIdx = byDay.indexOf(maxDay);

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 14 }}>
        <div className="st" style={{ marginBottom: 0 }}>📊 Spending by Day of Week</div>
        <span style={{ fontSize: 10, color: 'var(--mut)' }}>last 3 months</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 60, marginBottom: 6 }}>
        {byDay.map((amt, i) => {
          const pct = maxDay > 0 ? (amt / maxDay) * 100 : 0;
          const isTop = i === topDayIdx && amt > 0;
          return (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' }}>
              <div style={{
                width: '100%',
                height: pct + '%',
                minHeight: amt > 0 ? 4 : 0,
                background: isTop ? 'var(--ylw)' : 'var(--blu)',
                borderRadius: '3px 3px 0 0',
                transition: 'height .4s ease-out',
              }} />
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 8 }}>
        {DAYS.map((d, i) => (
          <div key={i} style={{
            flex: 1, textAlign: 'center', fontSize: 9,
            fontWeight: i === topDayIdx ? 800 : 500,
            color: i === topDayIdx ? 'var(--ylw)' : 'var(--mut)',
          }}>{d}</div>
        ))}
      </div>
      <div style={{ fontSize: 11, color: 'var(--mut)' }}>
        Most spending on <strong style={{ color: 'var(--ylw)' }}>{DAYS[topDayIdx]}s</strong> — {fc(maxDay / 3)}/mo avg · {fc(total / 3)}/mo total
      </div>
    </div>
  );
}
